import { useState } from "react";
import {
  RiUserLine,
  RiTimeLine,
  RiMailOpenLine,
  RiLinkM,
} from "react-icons/ri";

const SegmentationRules = ({ onSave }) => {
  const [rules, setRules] = useState({
    openRate: 30, // percentage
    clickRate: 15, // percentage
    followUpDelay: 72, // hours
    maxFollowUps: 2,
  });

  const segments = [
    {
      name: "Highly Engaged",
      criteria: "Opens > 50% and Clicks > 25%",
      icon: RiMailOpenLine,
      color: "success",
    },
    {
      name: "Needs Follow-Up",
      criteria: "No open within 72 hours",
      icon: RiTimeLine,
      color: "warning",
    },
    {
      name: "Inactive",
      criteria: "No engagement in 30 days",
      icon: RiUserLine,
      color: "danger",
    },
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {segments.map((segment) => (
          <div key={segment.name} className="card">
            <div className="flex items-center space-x-3">
              <div className={`p-3 rounded-lg bg-${segment.color}-50`}>
                <segment.icon className={`w-6 h-6 text-${segment.color}-500`} />
              </div>
              <div>
                <h3 className="font-semibold text-secondary-900">
                  {segment.name}
                </h3>
                <p className="text-sm text-secondary-600">{segment.criteria}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="card space-y-6">
        <h3 className="text-lg font-semibold text-secondary-900">
          Auto-Follow-Up Rules
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="label">Minimum Open Rate Target (%)</label>
            <input
              type="number"
              className="input-field"
              value={rules.openRate}
              onChange={(e) => setRules({ ...rules, openRate: e.target.value })}
            />
          </div>

          <div>
            <label className="label">Minimum Click Rate Target (%)</label>
            <input
              type="number"
              className="input-field"
              value={rules.clickRate}
              onChange={(e) =>
                setRules({ ...rules, clickRate: e.target.value })
              }
            />
          </div>

          <div>
            <label className="label">Follow-Up Delay (hours)</label>
            <input
              type="number"
              className="input-field"
              value={rules.followUpDelay}
              onChange={(e) =>
                setRules({ ...rules, followUpDelay: e.target.value })
              }
            />
          </div>

          <div>
            <label className="label">Maximum Follow-Ups</label>
            <input
              type="number"
              className="input-field"
              value={rules.maxFollowUps}
              onChange={(e) =>
                setRules({ ...rules, maxFollowUps: e.target.value })
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SegmentationRules;
